import { render, staticRenderFns } from "./Esport.vue?vue&type=template&id=1fa33c80&"
import script from "./Esport.vue?vue&type=script&lang=js&"
export * from "./Esport.vue?vue&type=script&lang=js&"
import style0 from "./Esport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports